import { render, staticRenderFns } from "./productosdeBaja.vue?vue&type=template&id=76c2dfe3"
import script from "./productosdeBaja.vue?vue&type=script&lang=js"
export * from "./productosdeBaja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports